/*
 * @Description: 周转筐 api
 * @Author: sunxiaodong
 * @Date: 2020-08-11 17:06:26
 * @LastEditors: sunxiaodong
 * @LastEditTime: 2020-08-11 20:44:28
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_BASE_WEB = "" } = e6ModuleBaseDataApi;

//获取周转筐管理列表数据
export function getPageByCondition(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/getPageByCondition`,
    method: "post",
    data
  });
}
//新增周转筐信息
export function insertInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/insertInfo`,
    method: "post",
    data
  });
}
//修改周转筐信息
export function modifyInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/modifyInfo`,
    method: "post",
    data
  });
}
//删除周转筐信息
export function deleteBatch(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/deleteBatch`,
    method: "post",
    data
  });
}
//查询周转筐详细信息
export function getInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/getInfo`,
    method: "post",
    data
  });
}
//周转筐名称唯一性校验
export function validName(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/validName`,
    method: "post",
    data
  });
}
//周转筐编码唯一性校验
export function validNo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/validNo`,
    method: "post",
    data
  });
}
//导出周转筐信息
export function exportPackage(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/exportPackage`,
    method: "post",
    data
  });
}

//获取周转筐历史记录表格
export function getHistoryList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/packageInfo/getHistoryList`,
    method: "post",
    data
  });
}
